import { createAction } from '@reduxjs/toolkit';
import { saveToLocalStorage, type SystemState, type UserState, type Chain } from '@/lib/helpers';
import { api } from '@/lib/trpc/client';
import type { AppDispatch, RootState } from '@/app/store';
import type { UserData } from '@/server/user';
import { isValidChain } from '@/lib/helpers/chain';

export const setUser = createAction<Partial<UserData>>('user/set');

export const setActiveChain = createAction<Chain>('user/active-chain/set');
export const setSystemInfo = createAction<SystemState['systemInfo']>(
  'user/active-chain/set-system'
);

export const _setActiveChain =
  (chain: string, cb?: (chain: Chain) => void) => (dispatch: AppDispatch) => {
    if (isValidChain(chain)) {
      dispatch(setActiveChain(chain));
      saveToLocalStorage('activeChain', chain);

      // Call the callback function if provided
      if (cb && typeof cb === 'function') {
        cb(chain);
      }
    }
  };

export const setActiveService = createAction<string>('user/active-service/set');
export const _setActiveService = (service: string) => (dispatch: AppDispatch) => {
  dispatch(setActiveService(service));
  saveToLocalStorage('activeService', service);
};

export const setActiveEnv = createAction<string>('user/active-env/set');
export const _setActiveEnv = (env: string) => (dispatch: AppDispatch) => {
  dispatch(setActiveEnv(env));
  saveToLocalStorage('activeEnv', env);
};

export const userRequestStarted = createAction('user/request/started');
export const userRequestFailed = createAction<string>('user/request/failed');

export const editUserSucceeded = createAction<Partial<UserState>>('user/put/succeeded');
export const editUser =
  (updateData: { phone: string; name: string }) =>
  (dispatch: AppDispatch, getState: () => RootState) => {
    dispatch(userRequestStarted());

    const state = getState();
    const productPageDataState = state.productPageData;
    const { productPageData } = productPageDataState;

    return api.user.updateProfile.mutate(updateData).then(
      ({ user }) => {
        const chainHiddenFields = productPageData?.chainHiddenFields || [];
        const _chainHiddenFields = chainHiddenFields.filter(
          (field: any) => !user.hiddenFields.includes(field)
        );
        const userHiddenFields = user.hiddenFields || [];
        const _userHiddenFields = [...userHiddenFields, ..._chainHiddenFields];
        dispatch(
          editUserSucceeded({
            user: { ...user, hiddenFields: _userHiddenFields },
          })
        );
      },
      (error) => {
        dispatch(userRequestFailed(error.message));
      }
    );
  };
